import { Button } from '@medely/ui-kit';
import useDialog from '@mp/hooks/useDialog';
import React from 'react';
import { CancelAssignmentModal } from './cancelModal/CancelAssignmentModal';
import { CancelAssignmentModalInfo } from './cancelModal/CancelAssignmentModalInfo';

export const AssignmentCancel = () => {
  const { closeDialog, open, openDialog } = useDialog();

  return (
    <>
      <Button variant="outlined" onClick={openDialog} testId="cancel-assignment-button" fullWidth>
        Cancel assignment
      </Button>
      <CancelAssignmentModal
        open={open}
        onClose={closeDialog}
        title="Cancel assignment"
        content={<CancelAssignmentModalInfo />}
        backButton={
          <Button
            onClick={closeDialog}
            variant="outlined"
            testId="cancel-assignment-modal-back-button"
            fullWidth
          >
            Back
          </Button>
        }
      />
    </>
  );
};
